// 9fbef606107a605d69c0edbcd8029e5d
import BUNDLEPRODUCT_CONSTANTS from './BundleProduct.constants';
import { DEFAULT_REDUCER_KEY } from '../../../../../utils/cache.util';
import DESIGN_YOUR_BAG_CONSTANTS from '../../DesignYourBag/container/DesignYourBag.constants';

const initialState = {
  [DEFAULT_REDUCER_KEY]: null,
  formName: [],
};

const BundleProductReducer = (state = initialState, action) => {
  const { payload = {}, type } = action;
  switch (type) {
    case BUNDLEPRODUCT_CONSTANTS.SET_BUNDLE_DETAILS:
      return { ...state, currentProduct: { ...payload.product }, breadCrumbs: payload.breadCrumbs };
    case BUNDLEPRODUCT_CONSTANTS.SET_BUNDLE_PRODUCTS_DETAILS:
      return { ...state, currentBundle: action.payload };
    case BUNDLEPRODUCT_CONSTANTS.UPDATE_BUNDLE_PRODUCT_ITEM: {
      const { index, product } = action.payload;
      return {
        ...state,
        currentBundle: state.currentBundle.map((item, idx) => (idx === index ? product : item)),
      };
    }
    case BUNDLEPRODUCT_CONSTANTS.SET_DEPARTMENT_BUNDLE_PRODUCTS:
      return { ...state, departmentBundleProducts: action.payload };
    case BUNDLEPRODUCT_CONSTANTS.SET_LOADING_STATE:
      return { ...state, ...payload };
    case BUNDLEPRODUCT_CONSTANTS.SET_PAGE_URL:
      return { ...state, pageUrl: payload };
    case BUNDLEPRODUCT_CONSTANTS.CLEAR_BUNDLE_DETAILS:
      return {
        ...state,
        currentProduct: null,
        currentBundle: null,
        departmentBundleProducts: null,
      };
    case BUNDLEPRODUCT_CONSTANTS.SET_ADD_TO_FAVORITE:
      // eslint-disable-next-line no-case-declarations
      let bundleMap = state.currentBundle;
      // eslint-disable-next-line consistent-return
      bundleMap = bundleMap.map((bundles) => {
        // eslint-disable-next-line no-param-reassign
        bundles.products.colorFitsSizesMap = bundles.products.colorFitsSizesMap.map((item) => {
          if (item.colorProductId === action.payload.pdpColorProductId) {
            // eslint-disable-next-line no-param-reassign
            item = {
              ...item,
              isFavorite: true,
              newItemId: action.payload.res && action.payload.res.newItemId,
              favoritedCount: action.payload.res && action.payload.res.favoritedCount,
            };
          }
          return item;
        });
        return bundles;
      });

      return { ...state, currentBundle: bundleMap };
    case BUNDLEPRODUCT_CONSTANTS.SET_IN_YOUR_BAG_COUNT:
      return {
        ...state,
        inYourBagData: action.payload,
      };
    case BUNDLEPRODUCT_CONSTANTS.SET_IS_BUNDLE:
      return { ...state, isBundle: action.payload };
    case BUNDLEPRODUCT_CONSTANTS.CARRY_FORWARD_IMG_URL:
      return { ...state, carryForwardImgUrl: action.payload };
    case DESIGN_YOUR_BAG_CONSTANTS.SET_FORM_NAME:
      return { ...state, formName: [...state?.formName, action?.payload?.data] };
    default:
      return { ...state };
  }
};

export default BundleProductReducer;
